/**
 * Exact API endpoint map extracted from the original Drivys source code.
 * Base URL: http://api.drivys.com:8080/api/
 * All paths are relative — prefix with base URL via Axios instance.
 */
export const endpoints = {
  auth: {
    login:           'admin/auth/login',
    collectorLogin:  'consumer/auth/login',
    me:              'admin/auth/who-am-i',
    meCollector:     'consumer/auth/who-am-i',
    meAssistant:     'consumer/auth/who-am-i',
    update:          'admin/auth/update-profile',
    delete:          'admin/auth/delete-profile',
    forgotPassword:  'consumer/auth/forgot-password-using-email',
    verifyOTP:       'consumer/auth/verify-password-using-email',
  },
  users: {
    list:            'admin/user/get-list',
    students:        'admin/student/get-student-list',
    studentsBySchool:'admin/student-by-school/get-student-list',
    getbyId:         'admin/user/get-user/',
    details:         'admin/trainers/get-trainer/',
    create:          'admin/auth/register',
    update:          'admin/user/user-update-by-id',
    delete:          'admin/user/delete-user-by-id',
    enum:            'public/enum/get-user-type-enum',
    genderenum:      'public/enum/get-gender-type-enum',
    gearenum:        'public/enum/get-gear-type-enum',
    listLanguages:   'public/languages',
    listCategories:  'public/category/get-category-list',
    listCities:      'public/city/get-city-list',
    listAreas:       'public/state-province/get-list',
    listVendor:      'public/vendor/get-vendor-list',
    listDialect:     'public/dialect/get-list',
    listPackage:     'public/package-trainer/get-trainer-package-vendor-list',
    listTrainers:    'public/trainers/get-trainers-list',
    listCategory:    'public/category/get-list',
    listAvailableSlots: 'public/trainers/get-available-slots',
    addressList:     'admin/user/address/get-user-address-list',
    getTrainerAddress:        'admin/user/address/get-trainer-address',
    getTrainerNearestAddress: 'admin/trainers/get-nearest-trainers-list',
    getStudentsUnderRadius:   'admin/studentMap/get-student-under-radius',
    createAddress:   'admin/user/address/create-update-user-address',
    deleteAddress:   'admin/user/address/delete-user-address',
    tracking:        'admin/user/tracking',
    deletedList:     'admin/user/tracking/deleted/all',
    userDocument: {
      createOrUpdate:    'admin/user-docs/create-user-docs',
      getList:           'admin/user-docs/get-user-doc-list',
      getById:           'admin/user-docs/get-doc',
      deleteById:        'admin/user-docs/delete-user-doc',
      deleteAllByUserId: 'admin/user-docs/delete-user-docs',
      approve:           'admin/user-docs/update-approve-doc',
    },
  },
  school: {
    list:            'admin/vendor/get-vendor-list',
    details:         'admin/vendor/get-vendor/',
    detailsAdmin:    'auth/vendor/get-vendor',
    create:          'admin/vendor/create-vendor-translation',
    delete:          'admin/vendor/delete-vendor/',
    address:         'admin/vendor/address/create-update-address',
    admin:           'admin/user/get-list',
    getSchoolAdmin:  'admin/user/get-school-admin-list',
    trainers:        'admin/trainers/get-trainer-list',
    addTrainer:      'admin/trainers/create-trainer',
    removeTrainer:   'admin/trainers/delete-trainer/',
    schoolTrainers:  'admin/trainers/get-school-trainer-list',
    messageToTrainer:'admin/message/message-to-trainer',
    createRewardTrainer: 'admin/reward/reward-to-trainer',
    package: {
      getPackageBySchool: 'admin/package/get-school-packge-list',
    },
    bulk: {
      addCommision: 'admin/vendor/bulk/update-commision',
    },
  },
  trainer: {
    getPackages:     'admin/package-trainer/get-trainer-packages/',
    createTrainer:   'admin/trainers/create-trainer',
    noschool:        'admin/user/get-trainer-list-non-vendor',
    workingHours: {
      createUpdate:  'admin/trainer-working-hours/create',
      deleteById:    'admin/trainer-working-hours/delete-by-id',
      getList:       'admin/trainer-working-hours/get-by-user-id',
    },
    shift: {
      create:        'admin/trainer-working-hours/shifts/set-shift-by-admin',
      get:           'admin/trainer-working-hours/shifts/get-shifts-by-admin',
      delete:        'admin/trainer-working-hours/shifts/delete-shift-by-admin',
    },
    leave: {
      list:         'admin/leave/get-leave-list',
      createUpdate: 'auth/leave/create-update-leave',
      deleteByDates:'auth/leave/delete-leave-by-dates',
    },
  },
  booking: {
    getList:         'admin/booking/get-bookings-list',
    getById:         'admin/booking/get-booking-by-id',
    updateStatus:    'admin/booking/update-booking-and-payment-status',
    getBookingById:  'admin/booking/get-bookings-by-student-id',
    rescheduleSlot:  'admin/booking/reschedule/reschedule-slot',
    getBookingStatus:'public/enum/get-booking-status-enum',
    getPaymentStatus:'public/enum/get-payment-status-type-enum',
    sessionRequests: 'admin/booking/session-requests',
    updateSessionStatusOnBehalf: 'admin/booking/update-session-status-on-behalf',
    sessionEdit:     'admin/booking/session/edit',
    sessionEditHistory: 'admin/booking/session/edit-history',
    changeTrainer:   'admin/booking/trainer-changing/change-free',
    changeTrainerList: 'consumer/booking/trainer-changing/get-trainer-list',
    trainerSwapHistory: 'admin/booking/trainer-swap-history/get-list',
    schoolAdmin: {
      getList:       'admin/booking/school/get-bookings-list',
      getById:       'admin/booking/school/get-booking-by-id',
    },
    refund: {
      list:          'admin/booking/refund/get-request-list',
      update:        'admin/booking/refund/update-status-by-booking-id',
      updateStatus:  'admin/booking/refund/update-refund-request',
      refundedList:  'admin/booking/refund/get-refunded-list',
      getById:       'admin/booking/refund/get-refund-details-by-booking-id',
      createRefund:  'admin/booking/refund/create-refund-request-by-booking-id',
    },
    autoReassign: {
      settings:      'admin/booking/auto-reassign/settings',
      issuesList:    'admin/booking/auto-reassign/issues/get-list',
      issuesCount:   'admin/booking/auto-reassign/issues/count',
      issuesResolve: 'admin/booking/auto-reassign/issues/resolve',
      historyList:   'admin/booking/auto-reassign-history/get-list',
    },
  },
  package: {
    list:            'admin/package/get-packge-list',
    details:         'admin/package/get-packge/',
    delete:          'admin/package/delete-packge/',
    createUpdate:    'admin/package/create-packge-translation',
    publicList:      'public/package/get-packge-list-with-global-package',
    bulkUpdate:      'admin/package/bulk-update',
  },
  packageTrainer: {
    list:   'admin/package-trainer/get-trainer-packages',
    create: 'admin/package-trainer/create-packge-trainer',
    delete: 'admin/package-trainer/delete-packge-trainer',
  },
  payouts: {
    trainerPayouts:  'admin/payout/get-by-trainers',
    schoolPayouts:   'admin/payout/get-by-vendors',
    getList:         'admin/payout/get-list',
    payToTrainer:    'admin/payout/transfer/trainer-pay',
    payToSchool:     'admin/payout/transfer/vendor-pay',
    payToAssistant:  'admin/payout/transfer/assistant-pay',
    getPayoutHistory:'admin/payout/transfer/get-list',
    getPayoutByBooking: 'admin/payout/get-by-bookings',
    getPayoutBySchool:  'admin/payout/get-trainers-payout-by-school',
    payoutDetailsAssistant: 'admin/payout/get-by-assistants',
  },
  // Real-time chat (v2 module over the support tables).
  chat: {
    conversations: 'v2/chat/conversations',
    adminStart: 'v2/chat/conversations/admin-start',
    messages: (id: number | string) => `v2/chat/conversations/${id}/messages`,
    assign: (id: number | string) => `v2/chat/conversations/${id}/assign`,
    status: (id: number | string) => `v2/chat/conversations/${id}/status`,
    read: (id: number | string) => `v2/chat/conversations/${id}/read`,
    agents: 'v2/chat/agents',
    usersSearch: 'v2/chat/users/search',
    unreadCount: 'v2/chat/unread-count',
  },
  // "All-in-One Package" — a bundle (e.g. "All-in-One Package") has variants
  // (e.g. "Start from scratch" / "I already have a licence"), each variant has
  // template items (file opening, eye test, ...). Students enroll into a
  // variant and their per-item progress is tracked separately below.
  allInOne: {
    bundles:      'admin/all-in-one/bundles',
    bundleSave:   'admin/all-in-one/bundle/save',
    bundleById:   (id: number | string) => `admin/all-in-one/bundle/${id}`,
    variantSave:  'admin/all-in-one/variant/save',
    variantById:  (id: number | string) => `admin/all-in-one/variant/${id}`,
    itemSave:     'admin/all-in-one/item/save',
    itemById:     (id: number | string) => `admin/all-in-one/item/${id}`,
    enrollments:      'admin/all-in-one/enrollments',
    enrollmentById:   (id: number | string) => `admin/all-in-one/enrollment/${id}`,
    enrollmentAssignTrainer: (id: number | string) => `admin/all-in-one/enrollment/${id}/assign-trainer`,
    enrollmentCancel:        (id: number | string) => `admin/all-in-one/enrollment/${id}/cancel`,
    enrollmentMarkPaid:      (id: number | string) => `admin/all-in-one/enrollment/${id}/mark-paid`,
    enrollmentItemStatus:    (id: number | string) => `admin/all-in-one/enrollment-item/${id}/status`,
  },
  // Trainer payout requests (v2 module: trainers request a payout, admin resolves).
  payoutRequests: {
    list:    'v2/admin/payout/requests/get-list',
    resolve: 'v2/admin/payout/requests/resolve',
    trainerBreakdown: 'v2/admin/payout/trainer-breakdown',
    paySessions: 'v2/admin/payout/pay-sessions',
  },
  // Wallet withdrawal requests — users cash out their wallet balance to a bank account.
  withdrawals: {
    list:    'admin/withdrawals',
    approve: (id: number | string) => `admin/withdrawals/${id}/approve`,
    // v2 module — unlike list/approve, this one lives on the v2 API (restClientV2).
    reject:  (id: number | string) => `v2/admin/withdrawals/${id}/reject`,
  },
  // Manual wallet credit/debit by an admin (v2 module).
  wallet: {
    students:    'v2/admin/wallet/students',
    editBalance: 'v2/admin/wallet/edit-balance',
    editHistory: 'v2/admin/wallet/edit-history',
  },
  certificate: {
    listAdmin:           'admin/certificate-request/get-requests-list-admin',
    list:                'admin/certificate-request/get-requests-list',
    addRequestByAdmin:   'admin/certificate-request/add-request',
    updatePaymentStatus: 'admin/certificate-request/update-request-payment-status',
    updateRequestStatus: 'admin/certificate-request/update-request-status-admin',
  },
  notification: {
    getList:           'admin/notification/get-list',
    getListAssistant:  'assistant/notification/get-list',
    getListCollector:  'collector/notification/get-list',
    getListSchoolAdmin:'admin/notification/get-list-by-school-admin',
    send:              'admin/notification/send-notification',
    updateFcmToken:    'consumer/auth/update-fcm-token',
  },
  pendingRequest: {
    trainerPendingRequest: 'admin/trainerPendingRequest/get-list',
    rejectAccept:          'admin/trainerPendingRequest/update-trainer-status',
    updateVerification:    'admin/trainerBySchoolAdmin/update-trainer-status',
    schoolAdminList:       'admin/trainerBySchoolAdmin/get-trainer-request-list',
  },
  // ── Live GPS / booking tracking ────────────────────────────────────────────
  // session detail accepts either the booking_session_id or the tracking_session_id;
  // the route endpoint is keyed by tracking_session_id.
  gps: {
    activeSessions: 'admin/gps/active-sessions',
    search:         'admin/gps/search',
    sessionDetail:  'admin/gps/session/',
    sessionRoute:   (trackingId: number | string) => `admin/gps/session/${trackingId}/route`,
  },
  analytics: {
    admin:              'admin/analytics/get-admin-analytics',
    schoolAdmin:        'admin/analytics/get-school-analytics',
    schoolAdminRevenue: 'admin/analytics/get-school-revenue',
    adminRevenue:       'admin/analytics/get-admin-revenue',
    studentInsights:    'admin/analytics/get-students-insights',
    trainerInsights:    'admin/analytics/get-trainers-analytics',
  },
  review: {
    getStudentReview:  'admin/reviews/get-students-reviews',
    getTrainerReview:  'admin/reviews/get-trainers-reviews',
    deleteReview:      'admin/reviews/delete-review?',
    updateReview:      'admin/reviews/update-review',
  },
  reviewSchoolAdmin: {
    getStudentReview:  'admin/review-school/get-students-reviews',
    getTrainerReview:  'admin/review-school/get-trainers-reviews',
    deleteReview:      'admin/review-school/delete-review?',
  },
  city: {
    list:              'admin/city/get-city-list',
    create:            'admin/city/create-city-translation',
    delete:            'admin/city/delete-city/',
    createPackage:     'admin/package-city/create-packge-city',
    getPackageList:    'admin/package-city/get-package-city',
    deletePackage:     'admin/package-city/delete-packge-city/',
    updateRescheduleBulk: 'admin/city/update-reschedule-setting-in-bulk',
  },
  state: {
    create:    'admin/state-province/create-state-translation',
    getById:   'admin/state-province/get-by-id',
    getList:   'admin/state-province/get-list',
    deleteById:'admin/state-province/delete-by-id',
  },
  dialect: {
    list:      'admin/dialect/get-list',
    createUpdate:'admin/dialect/create-update',
    getById:   'admin/dialect/get-by-id',
    delete:    'admin/dialect/delete-by-id',
  },
  language: {
    list:      'admin/user/languages',
    create:    'admin/user/languages',
    update:    'admin/user/languages/',
    delete:    'admin/user/languages/',
  },
  pickup: {
    list:        'admin/cityPickupExclusion/get-list',
    createUpdate:'admin/cityPickupExclusion/create-update',
    getById:     'admin/cityPickupExclusion/get-by-id',
    delete:      'admin/cityPickupExclusion/delete-by-id',
  },
  appSettings: {
    list:        'admin/appSetting/get-list',
    update:      'admin/appSetting/create-update',
  },
  termsAndConditions: {
    getList:     'admin/appSetting/get-tc',
    createUpdate:'admin/appSetting/createUpdateTC',
  },
  dynamicServiceSettings: {
    list:     'admin/dynamic-service/get-list',
    getById:  'admin/dynamic-service/get-by-id/',
    create:   'admin/dynamic-service/create',
    update:   'admin/dynamic-service/update/',
    delete:   'admin/dynamic-service/delete/',
  },
  coupon: {
    list:        'admin/discount/get-discount-list',
    delete:      'admin/discount/delete-discount/',
    createUpdate:'admin/discount/create-discount',
  },
  loyaltyProgram: {
    list:             'admin/trainer-rewards/get-rewards-list',
    createUpdate:     'admin/trainer-rewards/create-update-reward-translation',
    delete:           'admin/trainer-rewards/delete-reward-by-id',
    eligibleTrainers: 'admin/trainerAchievementReward/get-list',
    processReward:    'admin/trainerAchievementReward/ahievement-reward',
  },
  rolesAndPermission: {
    getRoles:          'admin/role/get-list',
    getPermissions:    'admin/permission/get-list',
    createRole:        'admin/role/create-update',
    createPermission:  'admin/permission/create-update',
    mapRoleToPermission: 'admin/role/permission-mapping/role-permission-mapping',
    listMappedRoles:   'admin/role/permission-mapping/get-list',
  },
  rolesAndPermissionSchoolAdmin: {
    getRoles:          'admin/access-control-for-school-admin/role/get-list-by-admin',
    getPermissions:    'admin/access-control-for-school-admin/permission/get-list-by-admin',
    createRole:        'admin/access-control-for-school-admin/role/create-by-admin',
    createPermission:  'admin/access-control-for-school-admin/permission/create-by-admin',
    mapRoleToPermission: 'admin/access-control-for-school-admin/permission-mapping/role-permission-mapping-by-admin',
    listMappedRoles:   'admin/access-control-for-school-admin/permission-mapping/get-list-by-admin',
  },
  // v2 RBAC (Fiber). `:id` segments are built in roleV2Service.
  rbac: {
    me:               'v2/admin/rbac/me',
    roles:            'v2/admin/rbac/roles',            // GET list · POST create
    role:             (id: number | string) => `v2/admin/rbac/roles/${id}`,             // GET · PUT · DELETE
    rolePermissions:  (id: number | string) => `v2/admin/rbac/roles/${id}/permissions`, // PUT
    userRoles:        (id: number | string) => `v2/admin/rbac/users/${id}/roles`,       // GET · PUT
  },
  // v2 role / permission / user mapping (platform admin).
  roleV2: {
    list:                'v2/admin/role/get-list',
    createUpdate:        'v2/admin/role/create-update',
    permissionList:      'v2/admin/role/permission-mapping/get-list',
    permissionMap:       'v2/admin/role/permission-mapping/role-permission-mapping',
    userMappingList:     'v2/admin/role/user-mapping/get-list',
    userMap:             'v2/admin/role/user-mapping/role-user-mapping',
  },
  // v2 role management for school admins, done by a platform admin.
  roleV2SchoolAdmin: {
    list:                'v2/admin/access-control-for-school-admin/role/get-list-by-admin',
    create:              'v2/admin/access-control-for-school-admin/role/create-by-admin',
    permissionList:      'v2/admin/access-control-for-school-admin/permission/get-list-by-admin',
    permissionMapList:   'v2/admin/access-control-for-school-admin/permission-mapping/get-list-by-admin',
    permissionMap:       'v2/admin/access-control-for-school-admin/permission-mapping/role-permission-mapping-by-admin',
    userMappingList:     'v2/admin/access-control-for-school-admin/user-role-mapping/get-list-by-admin',
    userMap:             'v2/admin/access-control-for-school-admin/user-role-mapping/role-user-mapping-by-admin',
  },
  support: {
    list:         'admin/support/get-list',
    // NOTE: no status-update endpoint exists in the old dashboard's API
    // surface — confirm the real one with backend before wiring an update.
  },
  slider: {
    list:        'admin/slider/get-slider-list',
    create:      'admin/slider/create-slider',
    update:      'admin/slider/update-slider',
    delete:      'admin/slider/delete-slider/',
    details:     'admin/slider/get-slider/',
  },
  collector: {
    getCashInHand:  'collector/cash/get-trainer-cash-in-hand-list',
    collectCash:    'collector/cash/cash-collection',
    collectedListPerTransaction: 'collector/cash/cash-collected-list-per-transaction',
    collectedListPerTrainer: 'collector/cash/cash-collected-list',
  },
  collectorAdminView: {
    cashInHand:    'admin/cash-collection/get-collector-cash-in-hand-list',
    collectedCash: 'admin/cash-collection/cash-collected-list-per-transaction',
    collectCash:   'admin/cash-collection/cash-collection',
  },
  commission: {
    listAdmin:             'admin/vendor/get-vendors-commission-list',
    trainerCommission:     'admin/trainers/get-school-trainer-commission-list',
    updateCommission:      'admin/trainers/set-school-trainer-commission',
  },
  profileUpdate: {
    list:          'admin/trainerProfileupdate/get-list',
    unverify:      'admin/trainerProfileupdate/un-verify',
    approveReject: 'admin/trainerProfileupdate/approve-or-reject-profile-picture',
  },
  reportPreview: {
    booking: 'admin/reports/preview/bookings',
    revenue: 'admin/reports/preview/revenue',
    trainer: 'admin/reports/preview/trainers',
    student: 'admin/reports/preview/students',
    school:  'admin/reports/preview/schools',
  },
  reportDownload: {
    booking: 'admin/reports/bookings',
    revenue: 'admin/reports/revenue',
    trainer: 'admin/reports/trainers',
    student: 'admin/reports/students',
    school:  'admin/reports/schools',
  },
  schoolReportPreview: {
    booking: 'admin/reportBySchool/bookings',
    revenue: 'admin/reportBySchool/revenues',
    trainer: 'admin/reportBySchool/trainers',
    student: 'admin/reportBySchool/students',
    school:  'admin/reportBySchool/school',
  },
  unattendedStudents: {
    list:          'admin/booking/noStudentShownUp/get-no-student-shown-up-session-list',
    approveOrReject: 'admin/booking/noStudentShownUp/approve-reject',
  },
  homeListing: {
    list:          'admin/home-listing/get-home-listing-list',
    createUpdate:  'admin/home-listing/create-home-listing',
    details:       'admin/home-listing/get-home-listing/',
    delete:        'admin/home-listing/delete-home-listing/',
    deleteTrainer: 'admin/home-listing/remove-trainer-by-trainer-id',
  },
  enum: {
    bookingMethod:  'public/enum/get-booking-method-type-enum',
    bookingStatus:  'public/enum/get-booking-status-enum',
    driverStatus:   'public/enum/get-driver-status-type-enum',
    paymentMethod:  'public/enum/get-payment-method-type-enum',     
    sessionStatus:  'public/enum/get-session-status-type-enum',
    sessionType:    'public/enum/get-session-type-enum',
    refundRequestStatus: 'public/enum/get-refund-request-status-enum',
    assistantAccess:     'public/enum/get-assistant-access-enum',
  },
  allimage: {
    create:         'auth/picture/upload-picture-multi',
    createSingle:   'auth/picture/upload-picture',
    list:           'auth/picture/get-picture',
  },
  assistant: {
    updateProfile:  'consumer/auth/update-profile',
    student: {
      list:    'assistant/student/get-student-list',
      add:     'assistant/student/register',
    },
    trainer: {
      list:    'assistant/trainer/get-trainer-list',
      packages:'assistant/trainer/get-trainer-package-mapping-list',
    },
    booking: {
      create:  'assistant/booking/create-booking',
      list:    'assistant/booking/get-booking-list',
      paymentList: 'admin/booking/assistant/get-payment-list',
      paymentApproveOrDecline: 'admin/booking/assistant/approved-or-decline',
    },
    payout: {
      list:    'assistant/transaction/transaction-list',
    },
    commission: {
      list:    'assistant/transaction/earning-list',
    },
    users: {
      getUserById: 'assistant/trainer/get-user/',
    },
    cashCollectedList: 'admin/assistant-collection/get-assistant-cash-in-hand-list',
    collectCash:       'admin/assistant-collection/cash-collection',
  },
}
// i am waiting for a clude ai update 